import { Box, FormControl, InputAdornment, makeStyles, OutlinedInput } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import React from 'react';

interface Props {
  onSearchChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const TreeSearch: React.FC<Props> = React.memo(({ onSearchChange = () => {} }) => {
  const classes = useStyles();

  return (
    <Box className={classes.searchField}>
      <FormControl fullWidth variant="outlined">
        <OutlinedInput
          onChange={onSearchChange}
          startAdornment={
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          }
          inputProps={{
            autoFocus: true,
          }}
          labelWidth={0}
        />
      </FormControl>
    </Box>
  );
});

const useStyles = makeStyles((theme) => ({
  searchField: {
    padding: theme.spacing(2),

    '& input': {
      height: '18px',
      minHeight: '18px',
    },
    '& .MuiInputBase-formControl': {
      minHeight: '32px',
    },
  },
}));

export default TreeSearch;
